import { AnyAction } from 'redux';

import { SET_DOCUMENT_FOCUS, SET_FOCUS } from './constants';

export const initialState = {
  focus: undefined,
  isDocumentFocused: false,
};

export const focusReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_FOCUS:
      return { ...state, focus: action.focus };
    case SET_DOCUMENT_FOCUS:
      return { ...state, isDocumentFocused: action.isDocumentFocused };
    default:
      return state;
  }
};
